import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  RiMailLine,
  RiLockLine,
  RiBuilding4Line,
  RiArrowLeftSLine,
} from "react-icons/ri";
import logo from "../../images/logo.png";
import db from "../../firebase";
import {
  collection,
  addDoc,
  doc,
  updateDoc,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import ReactLoading from "react-loading";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const MIN_PASS_LENGTH = 6;
const inputBase =
  "w-full border border-gray-200 outline-none py-2 px-8 rounded-lg";
const inputError =
  "w-full border border-red-400 outline-none py-2 px-8 rounded-lg";

let Register = (): any => {
  const [showPass, setShowPass] = useState(false);
  const [name, setName] = useState("");
  const [rut, setRut] = useState("");
  const [email, setEmail] = useState("");
  const [pass1, setPass1] = useState("");
  const [pass2, setPass2] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [errorField, setErrorField] = useState<
    "" | "name" | "rut" | "email" | "pass"
  >("");

  const navigate = useNavigate();
  const goBack = async () => {
    await navigate(-1);
  };
  const handlePassword = () => setShowPass(!showPass);

  // Cualquier cambio de campo limpia el error para poder reintentar sin recargar.
  const clearError = () => {
    if (errorMsg) setErrorMsg("");
    if (errorField) setErrorField("");
  };

  const fail = (field: typeof errorField, msg: string) => {
    setErrorField(field);
    setErrorMsg(msg);
    setLoading(false);
  };

  const createClient = async () => {
    const payload = { email, name, pass: pass1, rut, active: true };
    const payload2 = { email, name, time: Date.now() };
    const payload3 = { email, numero: 0 };
    await addDoc(collection(db, "users"), payload);
    await addDoc(collection(db, "listClient"), payload2);
    await addDoc(collection(db, "listClientNumberOrder"), payload3);
    await updateDoc(doc(db, "timeClien", "1"), { id: 0, time: Date.now() });
  };

  const handleSubmit = async () => {
    if (loading) return;
    setErrorMsg("");
    setErrorField("");

    // 1) Campos obligatorios
    if (name.trim() === "") return fail("name", "Ingresa el nombre.");
    if (rut.trim() === "") return fail("rut", "Ingresa el RUT.");
    if (email.trim() === "") return fail("email", "Ingresa el correo.");
    if (pass1 === "" || pass2 === "")
      return fail("pass", "Ingresa y repite la contraseña.");

    // 2) Formato de correo (R4/R6)
    if (!EMAIL_REGEX.test(email.trim()))
      return fail("email", "El correo no tiene un formato válido.");

    // 3) Largo de contraseña (R4)
    if (pass1.length < MIN_PASS_LENGTH)
      return fail(
        "pass",
        `La contraseña debe tener al menos ${MIN_PASS_LENGTH} caracteres.`
      );

    // 4) Contraseñas iguales
    if (pass1 !== pass2) return fail("pass", "Las contraseñas no coinciden.");

    setLoading(true);
    try {
      // 5) RUT ya registrado (R5)
      const rutSnap = await getDocs(
        query(collection(db, "users"), where("rut", "==", rut.trim()))
      );
      if (!rutSnap.empty)
        return fail("rut", "El usuario ya existe (RUT ya registrado).");

      // 6) Correo ya registrado (R4/R6)
      const emailSnap = await getDocs(
        query(collection(db, "users"), where("email", "==", email.trim()))
      );
      if (!emailSnap.empty)
        return fail("email", "Ya existe una cuenta con este correo.");

      // 7) Todo válido: recién aquí se crea (R6)
      await createClient();
      setLoading(false);
      await goBack();
    } catch (err: any) {
      console.error(err);
      fail("", err?.message || "Ocurrió un error al registrar. Intenta nuevamente.");
    }
  };

  return (
    <div className="bg-white p-8 rounded-lg w-96">
      <div className="mb-10">
        <RiArrowLeftSLine onClick={goBack} className="cursor-pointer" />
        <img className="h-auto max-w-xs" src={logo} />
        <h1 className="text-2xl uppercase font-bold text-center">
          Registro de Clientes
        </h1>
      </div>

      <div className="relative mb-8">
        <div className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-500">
          <RiBuilding4Line />
        </div>
        <input
          type="text"
          className={errorField === "name" ? inputError : inputBase}
          placeholder="Nombre"
          value={name}
          onChange={(e) => {
            setName(e.target.value);
            clearError();
          }}
        />
      </div>

      <div className="relative mb-8">
        <div className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-500">
          <RiBuilding4Line />
        </div>
        <input
          type="text"
          className={errorField === "rut" ? inputError : inputBase}
          placeholder="Rut Empresa"
          value={rut}
          onChange={(e) => {
            setRut(e.target.value);
            clearError();
          }}
        />
      </div>

      <div className="relative mb-8">
        <div className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-500">
          <RiMailLine />
        </div>
        <input
          type="email"
          className={errorField === "email" ? inputError : inputBase}
          placeholder="Correo Electronico"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            clearError();
          }}
        />
      </div>

      <div className="relative mb-8">
        <div className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-500">
          <RiLockLine onClick={handlePassword} className="cursor-pointer" />
        </div>
        <input
          type={showPass ? "text" : "password"}
          className={errorField === "pass" ? inputError : inputBase}
          placeholder="Clave"
          value={pass1}
          onChange={(e) => {
            setPass1(e.target.value);
            clearError();
          }}
        />
      </div>

      <div className="relative mb-5">
        <div className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-500">
          <RiLockLine onClick={handlePassword} className="cursor-pointer" />
        </div>
        <input
          type={showPass ? "text" : "password"}
          className={errorField === "pass" ? inputError : inputBase}
          placeholder="Repetir clave"
          value={pass2}
          onChange={(e) => {
            setPass2(e.target.value);
            clearError();
          }}
        />
      </div>

      <div>
        {errorMsg && (
          <div className="mb-3 bg-red-100 text-red-700 text-sm font-medium px-4 py-2 rounded-lg">
            {errorMsg}
          </div>
        )}

        {loading && (
          <div style={{ paddingLeft: "43%" }}>
            <ReactLoading type={"spin"} color={"blue"} height={"20%"} width={"20%"} />
          </div>
        )}

        <button
          className="mt-2 bg-sky-600 hover:bg-sky-700 disabled:opacity-60 text-white w-full py-2 px-6 rounded-lg"
          onClick={handleSubmit}
          disabled={loading}
        >
          Registrar
        </button>
      </div>
    </div>
  );
};
export default Register;
